module.exports = {

  productive: "#00AFEF",
  ERROR:"#F64E60",
  WHITE:"#FFF",
};